module.exports = "/_next/static/images/StartWithStrategy-d1d8bd42e300ae493d49c46eb19f82a7.webp";